import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import CONFIG from './../../config';
import { AuthService } from './auth.service';
import { LoadingService } from '../loading/loading.service';


@Injectable()
export class BackendService {

    constructor(
        private _http: HttpClient,
        private _authService: AuthService,
        private _loadingService: LoadingService
    ) { }

    getData(url) {
       // console.log("entered getdata backend service" + this._authService.token);
        this._loadingService.show();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this._authService.token}`
            })
        };
       // console.log(url, httpOptions);
        return this._http.get(url, httpOptions)
            // .map(response => {                
            //     if (response) {                   
            //         return response;
            //     } else {
            //         throw new Error('Error Getting Data');
            //     }
            // })
            // .catch(this.handleError)
            // .finally(() => {
            //     this._loadingService.hide();
            // });
    }

    deleteData(url) {
        this._loadingService.show();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this._authService.token}`
            })
        };
        return this._http.delete(url, httpOptions)
            // .map(response => {
            //     return response;
            // })
            // .catch(this.handleError)
            // .finally(() => {
            //     this._loadingService.hide();
            // });
    }   

    postData(newData, url) {
        //console.log(newData,url);
        this._loadingService.show();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this._authService.token}`
            })
        };
        const body = JSON.stringify(newData);
        return this._http.post(url, body, httpOptions)

            // .map(response => {
            //     return response;
            // })
            // .catch(this.handleError)
            // .finally(() => {
            //     this._loadingService.hide();
            // });
    }

    putData(updatedData, url) {
        this._loadingService.show();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this._authService.token}`
            })
        };
        const body = JSON.stringify(updatedData);
        return this._http.put(url, body, httpOptions)
            // .map(response => {
            //     return response;
            // })
            // .catch(this.handleError)
            // .finally(() => {
            //     this._loadingService.hide();
            // });

    }

    /*
    Utility error handler function for server errors
    */
    private handleError(error) {
        if (error.status && error.status === 401) {
            return Observable.throw('Session Expired- please log in');
        }

        return Observable.throw('Server Error');
    }

     // postFileData(fileToUpload: File): Observable<boolean> {
    //     const url = `${CONFIG.documentsApiUrlBase}/${this._authService.CustomerID}/${this._authService.Company}`;
    //     const formData: FormData = new FormData();
    //     const httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             'Authorization': `Bearer ${this._authService.token}`
    //         })
    //     };
    //     console.log(fileToUpload, fileToUpload.name);
    //     formData.append('File', fileToUpload, fileToUpload.name);
    //     //formData.append('ComponentId', componentId);
    //     //  formData.append('fileKey', fileToUpload, fileToUpload.name);
    //     console.log(formData);
    //     return this._http
    //         .post(url, formData, httpOptions)
    //         .map(() => { return true; })
    //         .catch((e) => this.handleError(e));
    // }

}